export const RouterLinks = {
  root: '/',

  login: '/auth/login',

  // registration
  signup: '/signup',
  registerationAccountType: '/signup/accounts/account-type',
  registerationTerms: '/signup/accounts/terms',
  registerationFCADetails: '/signup/accounts/advisor-details',
  registerationPersonalDetails: '/signup/accounts/registration',
  registerationVerification: '/signup/accounts/verification',
  registerationPasswordSetup: '/signup/accounts/password-set-up',
  signupSuccess: '/signup/success',

  // Register via Mail
  registerPersonalDetails: '/registration/main/personal-details',
  registerViaMailVerification: '/registration/main/verification',
  registerViaMailPasswordSetup: '/registration/main/password-set-up',

  // ONBOARDING ROUTES / PROFILE SETUP ROUTES
  personalDetails: '/onboarding/personal-details',
  expertiseDetails: '/onboarding/expertise-details',
  qualifications: '/onboarding/qualifications',
  accoladesUpload: '/onboarding/accolades-upload',
  workingPreferences: '/onboarding/working-preferences',
  clientData: '/onboarding/client-data',
  calenderSetup: '/onboarding/calendar-setup',
  notifications: '/onboarding/notifications',
  termsAndConditions: '/onboarding/terms-and-conditions',

  // MANAGE PORTFOLIO ROUTES
  managePortfolio: '/dashboard/manage-portfolio',
  previewCSV: '/dashboard/manage-portfolio/preview-csv',
  mps: '/dashboard/manage-portfolio/mps',
  mpsRebalancing: '/dashboard/manage-portfolio/rebalancing',

  // DASHBOARD ROUTES
  dashboard: '/dashboard',
  dashboardLink: '/dashboard/dashboard',
  advisorCopilot: '/dashboard/copilot',
  meetings: '/dashboard/meetings',
  clients: '/dashboard/clients',
  pricing: '/pricing',
  upgradePlan: '/upgrade-plan',
  support: '/dashboard/support',
  supportTicket: '/dashboard/support/ticket',
  training: '/dashboard/support/training',

  clientProfile: '/dashboard/client-profile',
  clientProfileAiAssistance: '/dashboard/ai-assistance',
  securedMessages: '/dashboard/secured-messages',
  inviteClient: '/dashboard/clients/invite-client',
  clientTasks: '/dashboard/client-tasks',
  protectionPlanning: '/dashboard/client-tasks/protection-planning',
  completePayment: '/complete-payment',

  selectPortfolio: '/dashboard/client-tasks/select-portfolio',

  protectionPlanningSolution: '/dashboard/client-tasks/solution',
  customTask: '/dashboard/client-tasks/custom-task',
  askAi: '/dashboard/ask-ai',
  askZeta: '/dashboard/ask-zeta',
  agentsConsumerDuty: '/dashboard/agents/consumer-duty',
  agentsIllustrations: '/dashboard/agents/illustrations',
  complianceReviews: '/dashboard/compliance/reviews',
  complianceNewReview: '/dashboard/compliance/new-review',
  complianceReviewDetails: '/dashboard/compliance/review-details',
  notificationsProfileSetup: '/dashboard/notifications',

  // FACT-FIND ROUTES
  factFindDocuments: '/dashboard/fact-find/documents',
  factFindInitialMeetingSummary: '/dashboard/fact-find/initial-meeting-summary',
  factFindPersonalInfo: '/dashboard/fact-find/personal-information',
  factFindAssets: '/dashboard/fact-find/assets',
  factFindProtectionSolution: '/dashboard/fact-find/protection-solution',
  factFindExperience: '/dashboard/fact-find/experience',
  factFindSummaryAndNotes: '/dashboard/fact-find/summary-and-notes',
  factFindBeneficiaries: '/dashboard/fact-find/beneficiaries',
  factFindExpenditure: '/dashboard/fact-find/expenditure',
  factFindIncome: '/dashboard/fact-find/income',
  factFindNextSteps: '/dashboard/fact-find/next-steps',
  factFindInvestmentSolution: '/dashboard/fact-find/investment-solution',
  factFindBenefitsAndInsurance: '/dashboard/fact-find/benefits-and-insurance',
  factFindLiabilites: '/dashboard/fact-find/liabilities',
  factFindHealthDetails: '/dashboard/fact-find/health-details',
  factFindFinancialPlanning: '/dashboard/fact-find/financial-planning',
  factFindRiskAssessment: '/dashboard/fact-find/risk-assessment',
  factFindReview: '/dashboard/fact-find/review',
  factFindGenerateReport: '/dashboard/fact-find/generate-report',
  factFindClientInteractionHub: '/dashboard/fact-find/client-interaction-hub',
  factFindGoalsAndTimeline: '/dashboard/fact-find/goals-timeline',
  // business FF
  factFindBusinessDetails: '/dashboard/fact-find/business-details',
  factFindBusinessKeyMembers: '/dashboard/fact-find/key-members',
  factFindBusinessFinancialInformation: '/dashboard/fact-find/financial-information',
  factFindBusinessLoans: '/dashboard/fact-find/loans',
  factFindBusinessAssetsPremise: '/dashboard/fact-find/assets-premise',
  factFindBusinessProfessionalAdvisors: '/dashboard/fact-find/professional-advisors',
  factFindBusinessPensions: '/dashboard/fact-find/pensions',
  factFindBusinessCovers: '/dashboard/fact-find/covers',
  factFindBusinessEmployeeBenefits: '/dashboard/fact-find/employee-benefits',
  clientDetailsAI: '/dashboard/fact-find/client-details-ai',
  clientDetailsCheckList: '/dashboard/fact-find/client-details-check-list',
  // MANAGED_CLIENT
  managedClientDocuments: '/dashboard/managed-client/documents',
  managedClientInitialMeetingSummary: '/dashboard/managed-client/initial-meeting-summary',
  managedClientPersonalInfo: '/dashboard/managed-client/personal-information',
  managedClientAssets: '/dashboard/managed-client/assets',
  managedClientProtectionSolution: '/dashboard/managed-client/protection-plan',
  managedClientInvestmentSolution: '/dashboard/managed-client/investment-plan',
  managedClientRetirementPlanning: '/dashboard/managed-client/retirement-planning',
  managedClientIncome: '/dashboard/managed-client/income',
  managedClientExpenditure: '/dashboard/managed-client/expenditure',
  managedClientRiskAssessment: '/dashboard/managed-client/risk-assessment',
  managedClientLiabilites: '/dashboard/managed-client/liabilities',
  managedClientHealthDetails: '/dashboard/managed-client/health-details',
  managedClientNominees: '/dashboard/managed-client/nominees',
  managedClientInteractionHub: '/dashboard/managed-client/client-interaction-hub',
  managedClientPortfolio: '/dashboard/managed-client/portfolio',
  managedClientPortfolioDetail: '/dashboard/managed-client/portfolio-detail',
  clientPortfolio: '/dashboard/portfolio',

  // client info
  clientInfo: '/dashboard/client-info',
  clientInfoZetaAI: '/dashboard/client-info/zeta-ai',
  clientInfoZetaAIAdvise: '/dashboard/client-info/zeta-ai-advise',
  clientInfoOverview: '/dashboard/client-info/overview',
  clientInfoSecureMessage: '/dashboard/client-info/secure-message',
  clientInfoInitialMeetingSummary: '/dashboard/client-info/initial-meeting-summary',
  clientInfoClientInteractionHub: '/dashboard/client-info/client-interaction-hub',
  clientInfoBilling: '/dashboard/client-info/billing',
  clientInfoDocuments: '/dashboard/client-info/documents',
  clientInfoHouseHold: '/dashboard/client-info/household',
  clientInfoAdvisoryActions: '/dashboard/client-info/advisory-actions',
  clientInfoConflictResolution: '/dashboard/client-info/conflict-resolution',
  clientInfoAskZeta: '/dashboard/client-info/ask-zeta',
  clientInfoBusinessReviews: '/dashboard/client-info/business-reviews',
  clientInfoBusinessProfile: '/dashboard/client-info/business-profile',
  clientInfoPlans: '/dashboard/client-info/plans',
  clientInfoFactFind: '/dashboard/client-info/discovery',
  clientInfoKYCAML: '/dashboard/client-info/kyc-aml',
  clientInfoGoalsAndTimeline: '/dashboard/client-info/goals-timeline',
  clientInfofinancialPlanningTask: '/dashboard/client-info/financial-planning',
  clientInfoinvestmentPlanning: '/dashboard/client-info/investment-planning',
  clientInfoinvestmentPlanningSummary: '/dashboard/client-info/investment-planning-summary',
  clientInfoprotectionPlanning: '/dashboard/client-info/protection-planning',
  clientInfoprotectionPlanningSolution: '/dashboard/client-info/solution',
  clientInfocustomTask: '/dashboard/client-info/custom-task',
  clientInfofactFindTasks: '/dashboard/client-info/fact-find-tasks',
  clientInfoReports: '/dashboard/client-info/reports',
  //workplace routes
  clientInfoWorkplaceTasksActivities: '/dashboard/client-info/workplace/tasks-activities',
  clientInfoWorkplaceParaplanning: '/dashboard/client-info/workplace/paraplanning',
  clientInfoWorkplaceRecommendation: '/dashboard/client-info/workplace/recommendation',
  clientInfoWorkplaceReview: '/dashboard/client-info/review',
  clientInfoWorkplaceExecution: '/dashboard/client-info/workplace/execution',
  clientInfoWorkplaceMeetingNotes: '/dashboard/client-info/meeting-notes',
  clientInfoWorkplacePlansNew: '/dashboard/client-info/plans-new',
  clientInfoWorkplacePlansRetirement: '/dashboard/client-info/plans-new/retirement',
  clientInfoWorkplacePlansProtection: '/dashboard/client-info/plans-new/protection',
  clientInfoWorkplacePlansInvestment: '/dashboard/client-info/plans-new/investment',
  clientInfoWorkplacePlansEstate: '/dashboard/client-info/plans-new/estate',
  clientInfoWorkplacePlansMortgage: '/dashboard/client-info/plans-new/mortgage',
  clientInfoWorkplacePlansTax: '/dashboard/client-info/plans-new/tax',
  clientInfoWorkplacePlansSetup: '/dashboard/client-info/plans-new/setup',
  clientInfoFinancialPlanningWorkspace: '/dashboard/client-info/financial-planning-workspace',
  clientInfoFinancialPlanningWorkspaceMock: '/dashboard/client-info/financial-planning-workspace/mock',
  clientInfoRetirementPlanningWorkspace: '/dashboard/client-info/financial-planning-workspace',
  clientInfoProtectionPlanningWorkspace: '/dashboard/client-info/protection-planning-workspace',
  clientInfoInvestmentPlanningWorkspace: '/dashboard/client-info/investment-planning-workspace',
  clientInfoAdvicePlanningWorkspace: '/dashboard/client-info/advice-planning-workspace',

  // Para Planner
  paraPlannerInitialMeetingSummary: '/dashboard/para-planner/initial-meeting-summary',
  paraPlannerRiskAssessment: '/dashboard/para-planner/risk-assessment',
  ParaPlannerPersonalInfo: '/dashboard/para-planner/personal-information',
  paraPlannerIncome: '/dashboard/para-planner/income',
  paraPlannerExpenditure: '/dashboard/para-planner/expenditure',
  paraPlannerAssets: '/dashboard/para-planner/assets',
  paraPlannerLiabilites: '/dashboard/para-planner/liabilities',
  paraPlanningHealthDetails: '/dashboard/para-planner/health-details',
  paraPlanningBenefitsAndInsurance: '/dashboard/para-planner/benefits-and-insurance',
  paraPlanningBeneficiaries: '/dashboard/para-planner/beneficiaries',
  paraPlanningGoalsAndTimeline: '/dashboard/para-planner/goals-timeline',
  paraPlanningReports: '/dashboard/para-planner/reports',

  // PROFILE SETUP ROUTES
  profileSetup: '/profile-setup',
  organisationProfile: '/profile-setup/organisation-profile',
  userManagement: '/profile-setup/user-management',
  myProfile: '/profile-setup/my-profile',
  changePassword: '/profile-setup/change-password',
  modelPortfolios: '/profile-setup/model-portfolios',
  riskAssessment: '/profile-setup/risk-assessment',
  financialPlanning: '/profile-setup/financial-planning',
  adviceTemplates: '/profile-setup/advice-templates',
  documentManagement: '/profile-setup/document-management',
  feesAndChargesManagement: '/profile-setup/fees-and-charges-management',
  factFindConfiguration: '/profile-setup/fact-find-configuration',
  clientCommunication: '/profile-setup/client-communication',
  crm: '/profile-setup/crm',
  certificationsAndExpertise: '/profile-setup/certifications-and-expertise',
  certificationsAndExpertiseCert: '/profile-setup/certifications-and-expertise/certifications',
  certificationsAndExpertiseExpertise: '/profile-setup/certifications-and-expertise/expertise',
  certificationsAndExpertiseProfessionalBackground: '/profile-setup/certifications-and-expertise/professional-background',
  firmProfileIncomplete: '/firm-profile-incomplete',

  billingAndInvoice: '/profile-setup/billing-and-invoice',

  // MY-TASKS-ROUTES
  myTasks: '/dashboard/my-tasks',
  createSolution: '/dashboard/my-tasks/create-solution',
  report: '/dashboard/my-tasks/report',

  meetingConfiguration: '/profile-setup/meeting-configuration',

  // MEETINGS ROUTES
  availability: '/dashboard/meetings/availability',

  // Others
  forbidden: '/403',
};
